import { AnalyticsService } from "./analytics.service";

import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

import * as $ from 'jquery';

export default class CheckEligibility {

	constructor() { }

	isBeforeToday(date: any, component: any) {
		let inputdate = new Date(date); 
		let todayDate = new Date();
		let day = todayDate.getDate();
		let month = todayDate.getMonth();
		let year = todayDate.getFullYear();
		todayDate = new Date(year, month, day)
		let difference = inputdate < todayDate;
		let form_group = $(component).closest('.form__group');
		if(difference){
			form_group.removeClass('form__group--error');
			return true;
		}
		form_group.addClass('form__group--error');
		return false;
	}

	validateDOB(value: any) {
		let inputdate = new Date(value); 
		let todayDate = new Date();
		let thisMonth = todayDate.getMonth();
		let thisYear = todayDate.getFullYear();
		let thisDay = todayDate.getDate();
		let monthBirthday = inputdate.getMonth(); 
		let yearBirthday = inputdate.getFullYear();
		let dayBirthday = inputdate.getDate();
		let yearDifference = thisYear - yearBirthday;
		if (thisMonth == monthBirthday){
		  if (thisDay < dayBirthday){
			yearDifference = yearDifference -1;
		  }
		}
		else {
		  if (thisMonth < monthBirthday) {
			yearDifference = yearDifference -1;
		  }
		}
		if(yearDifference >= 18){
		  return true;
		}
		return false;
	}

	validateDateEstablished(value: any) {
		let inputdate = new Date(value); 
		let todayDate = new Date();
		let thisMonth = todayDate.getMonth();
		let thisYear = todayDate.getFullYear();
		let thisDay = todayDate.getDate();
		let monthBirthday = inputdate.getMonth(); 
		let yearBirthday = inputdate.getFullYear();
		let dayBirthday = inputdate.getDate();
		let yearDifference = thisYear - yearBirthday;
		if (thisMonth == monthBirthday){
		  if (thisDay < dayBirthday){
			yearDifference = yearDifference -1;
		  }
		}
		else {
		  if (thisMonth < monthBirthday) {
			yearDifference = yearDifference -1;
		  }
		}
		if(yearDifference >= 1){
		  return true;
		}
		return false;
	}

	equalAfricanCountries(nationality, residence) {
		// let countries: any = ["AO","BW","CD","CG","GH","KE","LS","MW","MU","MZ","NA","NG","ZA","SZ","TZ","UG","ZM","ZW"];ˀ
		let countries: any = ["AO","BF","BI","BJ","BW","CD","CF","CG","CI","CM","DJ","DZ","EG","ER","ET","GA","GH","GM","GN","GQ","GW","KE","LR","LS","MA","MG","ML","MR","MU","MW","MZ","NA","NE","NG","RW","SC","SD","SL","SN","SO","ST","SZ","TD","TG","TN","TZ","UG","ZA","ZM","ZW"];
		let valid: boolean = false;
		countries.forEach(country => {
			if(nationality == country && residence == nationality){
				valid = true;			
			}
		});
		if(valid){
			return true;
		}else{
			return false;
		}
	}

	equalOffshore(nationality, residence) {
		let countries: any = ["GG","IM","JE","GB"];
		let valid: boolean = false;
		countries.forEach(country => {
			if(nationality == country && residence == nationality){
				valid = true;			
			}
		});
		if(valid){
			return true;
		}else{
			return false;
		}
	}

	allowCountryExPats(nationality, residence) {
		let countries: any = ["AU","GB","IE","US","ZW"];
		let valid: boolean = false;
		countries.forEach(country => {
			if(residence == country && nationality != residence){
				valid = true;			
			}
		});
		if(valid){
			return true;
		}else{
			return false;
		}
	}

	allowCountryOther(nationality, residence) {
		let countries: any = ["AU","GB","IE","US","ZW"];
		let valid: boolean = false;
		countries.forEach(country => {
			if(residence != country && nationality != residence){
				valid = true;			
			}
		});
		if(valid){
			return true;
		}else{
			return false;
		}
	}

	changeButtons(response: string, modalId: any, result: any) {
		let buttons = Array.from(document.querySelectorAll('.button[data-modal='+modalId+']'));
		if(buttons.length > 0){
			buttons.forEach(button => {

				let resultEligibility = "notvalid";

				// product offering page
				if(button.closest('.product-card__buttons')) {

					let parentContainer = button.closest('.product-card__buttons');
					let eligibleContainer = parentContainer.querySelector('.product-offering-exchange__eligibility');
					let eligibilityButton = parentContainer.querySelector('div[data-buttonclass=Eligibility]');
					eligibilityButton.classList.add('d-none');
	
					let message = `<div class="row">`;
					message += `<div class="col-12">`;
	
					if(response == 'apply'){
						resultEligibility = "apply";
						let applyButtonContainer = parentContainer.querySelector('div[data-buttonclass=Apply]');
						applyButtonContainer.classList.remove('d-none');
						let applyButton = applyButtonContainer.querySelector('a');
						message += `<div class="product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--eligible">`;
						message += `You're eligible for this product.`;
						message += `</div>`;
						if(result){
							if(result.leadID) {
								applyButton.setAttribute('href', 'javascript:void(0)');
								applyButton.setAttribute('data-leadid', result.leadID);
							}
						}
					}
	
					if(response == 'callmeback'){
						resultEligibility = "callmeback";
						let callmebackButtonContainer = parentContainer.querySelector('div[data-buttonclass=CallMeBack]');
						callmebackButtonContainer.classList.remove('d-none');
						let callmebackButton = callmebackButtonContainer.querySelector('a');
						message += `<div class="product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--eligible">`;
						message += `You're eligible for this product.`;
						message += `</div>`;
						if(result){
							if(result.leadID) {
								callmebackButton.setAttribute('data-leadid', result.leadID);
							}
						}
					}
	
					if(response == 'contactus'){
						resultEligibility = "contactus";
						let contactButton = parentContainer.querySelector('div[data-buttonclass=ContactUs]');
						contactButton.classList.remove('d-none');
						message += `<div class="product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--invalid">`;
						message += `You're not eligible for this product. <a href="javascript:;" class="js-apply-now-modal-open js-recheck-eligibility" data-modal="${modalId}">Recheck</a>`;
						message += `</div>`;
					}	

					message += `</div>`;
					message += `</div>`;
	
					let innerMessageText = document.createRange().createContextualFragment(message);
					eligibleContainer.insertBefore(innerMessageText, eligibleContainer.firstChild);

				}			
				
				// detailed product card
				if(button.closest('.detailed-product-card-exchange')){		
					
					let parentContainer = button.closest('.detailed-product-card-exchange');	
					let eligibilityButton = parentContainer.querySelector('div[data-buttonclass=Eligibility]');
					let eligibilityMessage = parentContainer.querySelector('.detailed-product-card-exchange__eligibility-message');
					eligibilityButton.classList.add('d-none');		
	
					if(response == 'apply'){
						resultEligibility = "apply";
						let applyButtonContainer = parentContainer.querySelector('div[data-buttonclass=Apply]');
						let applyButton = applyButtonContainer.querySelector('a');
						applyButtonContainer.classList.remove('d-none');
						eligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--eligible');
						eligibilityMessage.innerHTML = `You're eligible for this product.`;
						if(result){
							if(result.leadID) {
								applyButton.setAttribute('href', 'javascript:void(0)');
								applyButton.setAttribute('data-leadid', result.leadID);
							}
						}
					}
	
					if(response == 'callmeback'){
						resultEligibility = "callmeback";
						let callmebackButtonContainer = parentContainer.querySelector('div[data-buttonclass=CallMeBack]');
						let callmebackButton = callmebackButtonContainer.querySelector('a');
						callmebackButtonContainer.classList.remove('d-none');
						eligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--eligible');
						eligibilityMessage.innerHTML = `You're eligible for this product.`;
						if(result){
							if(result.leadID) {
								callmebackButton.setAttribute('data-leadid', result.leadID);
							}
						}
					}
	
					if(response == 'contactus'){
						resultEligibility = "contactus";
						let contactButton = parentContainer.querySelector('div[data-buttonclass=ContactUs]');
						contactButton.classList.remove('d-none');
						eligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--invalid');
						eligibilityMessage.innerHTML = `You're not eligible for this product. <a href="javascript:;" class="js-apply-now-modal-open js-recheck-eligibility" data-modal="${modalId}">Recheck</a>`;
					}	

				}

				if(button.closest('.comparison-exchange__product__section')){
					
					let parentContainer = button.closest('.comparison-exchange__product__section')	
					let eligibilityButtonContainer = parentContainer.querySelector('div[data-buttonclass=Eligibility]');
					let eligibilityButton = eligibilityButtonContainer.querySelector('a');
					let eligibilityMessage = parentContainer.querySelector('.comparison-exchange__product__section-eligibility--message');
					eligibilityButton.classList.add('d-none');		
	
					if(response == 'apply'){
						resultEligibility = "apply";
						let applyButtonContainer = parentContainer.querySelector('div[data-buttonclass=Apply]');
						let applyButton = applyButtonContainer.querySelector('a');
						applyButton.classList.remove('d-none');
						eligibilityMessage.innerHTML = `<div class="comparison-exchange__eligibility-message comparison-exchange__eligibility-message--eligible">You're eligible for this product.</div>`;
						if(result){
							if(result.leadID) {
								applyButton.setAttribute('href', 'javascript:void(0)');
								applyButton.setAttribute('data-leadid', result.leadID);
							}
						}
					}
	
					if(response == 'callmeback'){
						resultEligibility = "callmeback";
						let callmebackButtonContainer = parentContainer.querySelector('div[data-buttonclass=CallMeBack]');
						let callmebackButton = callmebackButtonContainer.querySelector('a');
						callmebackButton.classList.remove('d-none');
						eligibilityMessage.innerHTML = `<div class="comparison-exchange__eligibility-message comparison-exchange__eligibility-message--eligible">You'reˀ eligible for this product.</div>`;
						if(result){
							if(result.leadID) {
								callmebackButton.setAttribute('data-leadid', result.leadID);
							}
						}
					}
	
					if(response == 'contactus'){
						resultEligibility = "contactus";
						let contactButtonContainer = parentContainer.querySelector('div[data-buttonclass=ContactUs]');
						let contactButton = contactButtonContainer.querySelector('a');
						contactButton.classList.remove('d-none');
						eligibilityMessage.innerHTML = `<div class="comparison-exchange__eligibility-message comparison-exchange__eligibility-message--invalid">You're not eligible for this product. <a href="javascript:;" class="js-apply-now-modal-open js-recheck-eligibility" data-modal="${modalId}">Recheck</a></div>`;
					}

				}

				if(button.closest('.comparison-exchange__product__eligiblity__mobile')){
					
					let parentContainer = button.closest('.comparison-exchange__product__eligiblity__mobile')	
					let eligibilityButtonContainer = parentContainer.querySelector('div[data-buttonclass=Eligibility]');
					let eligibilityButton = eligibilityButtonContainer.querySelector('a');
					let eligibilityMessage = parentContainer.querySelector('.comparison-exchange__product__section-eligibility--message--mobile');
					eligibilityButton.classList.add('d-none');		
	
					if(response == 'apply'){
						resultEligibility = "apply";
						let applyButtonContainer = parentContainer.querySelector('div[data-buttonclass=Apply]');
						let applyButton = applyButtonContainer.querySelector('a');
						applyButton.classList.remove('d-none');
						eligibilityMessage.innerHTML = `<div class="comparison-exchange__eligibility-message comparison-exchange__eligibility-message--eligible">You're eligible for this product.</div>`;
						if(result){
							if(result.leadID) {
								applyButton.setAttribute('href', 'javascript:void(0)');
								applyButton.setAttribute('data-leadid', result.leadID);
							}
						}
					}
	
					if(response == 'callmeback'){
						resultEligibility = "callmeback";
						let callmebackButtonContainer = parentContainer.querySelector('div[data-buttonclass=CallMeBack]');
						let callmebackButton = callmebackButtonContainer.querySelector('a');
						callmebackButton.classList.remove('d-none');
						eligibilityMessage.innerHTML = `<div class="comparison-exchange__eligibility-message comparison-exchange__eligibility-message--eligible">You're eligible for this product.</div>`;
						if(result){
							if(result.leadID) {
								callmebackButton.setAttribute('data-leadid', result.leadID);
							}
						}
					}
	
					if(response == 'contactus'){
						resultEligibility = "contactus";
						let contactButtonContainer = parentContainer.querySelector('div[data-buttonclass=ContactUs]');
						let contactButton = contactButtonContainer.querySelector('a');
						contactButton.classList.remove('d-none');
						eligibilityMessage.innerHTML = `<div class="comparison-exchange__eligibility-message comparison-exchange__eligibility-message--invalid">You're not eligible for this product. <a href="javascript:;" class="js-apply-now-modal-open js-recheck-eligibility" data-modal="${modalId}">Recheck</a></div>`;
					}

				}
				
				// save outcome
				let storageEligibility: any = localStorage.getItem('eligibility');
				if(!storageEligibility){
					storageEligibility = {};
					if(result){
						if(result.leadID) {
							storageEligibility[modalId] = {
								result: resultEligibility,
								leadID: result.leadID
							};
						}
					}else{
						storageEligibility[modalId] = {
							result: resultEligibility
						};
					}
					localStorage.setItem('eligibility', JSON.stringify(storageEligibility));
				}else{
					storageEligibility = JSON.parse(storageEligibility);
					if (!storageEligibility[modalId]) {
						if(result){
							if(result.leadID){
								storageEligibility[modalId] = {
									result: resultEligibility,
									leadID: result.leadID
								};
							}
						}else{
							storageEligibility[modalId] = {
								result: resultEligibility
							};
						}
						localStorage.setItem('eligibility', JSON.stringify(storageEligibility));
					}
				}

			});
		}
	}

}



// WEBPACK FOOTER //
// ./services/check-eligibility.service.ts